import { Card, Layout, Text } from '@loadsmart/loadsmart-ui'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { IntegrationTestCaseDetail } from 'common/types/kraken-core/IntegrationTest'
import FileViewer from 'molecules/FileViewer/FileViewer'

export interface IntegrationTestCaseDetailInputDefinitionProps {
  testCase: IntegrationTestCaseDetail
  onChange: (propertyName: string, value: any) => void
}

export default function IntegrationTestCaseDetailInputtDefinition(
  props: IntegrationTestCaseDetailInputDefinitionProps
) {
  const handleChange = (value: any) => {
    props.onChange('input_definition', value)
  }

  return (
    <Card>
      <Card.Title>
        <Layout.Stack>
          <Text variant="heading-sm-bold">Input Definition</Text>
          <Text variant="body">To define what are the input arguments</Text>
        </Layout.Stack>
      </Card.Title>
      <Card.Separator />
      <Card.Body>
        <div>
          <Accordion>
            <AccordionSummary>Payload</AccordionSummary>
            <AccordionDetails>
              <FileViewer content="" contentType="" options={{}} />
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary>Headers</AccordionSummary>
            <AccordionDetails>
              <FileViewer content="" contentType="" options={{}} />
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary>Mocks</AccordionSummary>
            <AccordionDetails />
          </Accordion>
        </div>
      </Card.Body>
    </Card>
  )
}
